import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// The one refusal that means the attempt is not there for this patient, such
// as somebody else's; any other failure is a failure to load it.
const notFound = 'This questionnaire was not found';

// One attempt with everything its screens show: the questionnaire's wording,
// its answer scale and the answers so far. attempt is undefined while loading
// or when the read failed, and null when the attempt cannot be read for this
// patient; error and retry are useLoad's.
//
// reload is what a screen calls after saving, so it shows what the service
// now holds.
export function useAttempt(id) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Attempt($id: ID!) {
        attempt(id: $id) {
          id status assignedBy submittedAt
          answers { position value }
          questionnaire { name version language instructions items { position text } options { value label } }
        }
      }`,
      variables: { id }
    }).then(function(data) {
      return data.attempt;
    });
  }, [ graphql, id ]);

  const { data, error, retry, reload } = useLoad(read);

  return useMemo(function() {
    if (error === notFound) {
      return { attempt: null, retry, reload };
    }

    return { attempt: data, error, retry, reload };
  }, [ data, error, retry, reload ]);
}
